// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IAddressSourceType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class AddressSourceType implements IAddressSourceType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Change of Address Notice or Letter AddressSourceType
	**/
    get ChangeofAddressNoticeorLetter(): IAddressSourceType {
        return this.FromId(5);
    }
    /**
		Returns Application AddressSourceType
	**/
    get Application(): IAddressSourceType {
        return this.FromId(1);
    }
    /**
		Returns Citation or Abstract AddressSourceType
	**/
    get CitationorAbstract(): IAddressSourceType {
        return this.FromId(2);
    }
    /**
		Returns SR22 or SR26 Form AddressSourceType
	**/
    get SR22orSR26Form(): IAddressSourceType {
        return this.FromId(3);
    }
    /**
		Returns Database Conversion AddressSourceType
	**/
    get DatabaseConversion(): IAddressSourceType {
        return this.FromId(4);
    }
    /**
		Returns Telephone AddressSourceType
	**/
    get Telephone(): IAddressSourceType {
        return this.FromId(6);
    }
    /**
		Returns Supplements AddressSourceType
	**/
    get Supplements(): IAddressSourceType {
        return this.FromId(7);
    }
    /**
		Returns Traffic Survival School Assignment Form AddressSourceType
	**/
    get TrafficSurvivalSchoolAssignmentForm(): IAddressSourceType {
        return this.FromId(8);
    }
    /**
		Returns United States Post Office AddressSourceType
	**/
    get UnitedStatesPostOffice(): IAddressSourceType {
        return this.FromId(9);
    }
    /**
		Returns Verimove AddressSourceType
	**/
    get Verimove(): IAddressSourceType {
        return this.FromId(10);
    }
    /**
		Returns Warrant AddressSourceType
	**/
    get Warrant(): IAddressSourceType {
        return this.FromId(11);
    }
    /**
		Returns Service Arizona AddressSourceType
	**/
    get ServiceArizona(): IAddressSourceType {
        return this.FromId(12);
    }
    /**
		Returns AZ MVD Now AddressSourceType
	**/
    get AZMVDNow(): IAddressSourceType {
        return this.FromId(13);
    }
    /**
		Returns Verbal AddressSourceType
	**/
    get Verbal(): IAddressSourceType {
        return this.FromId(14);
    }
    /**
		Returns FAA AddressSourceType
	**/
    get FAA(): IAddressSourceType {
        return this.FromId(15);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('5', { id: 5, value: 'ChangeofAddressNoticeorLetter', displayValue: 'Change of Address Notice or Letter', description: 'Change of Address Notice or Letter', sortOrder: 1, active: true });
        this._dictionary.add('1', { id: 1, value: 'Application', displayValue: 'Application', description: 'Application', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'CitationorAbstract', displayValue: 'Citation or Abstract', description: 'Citation or Abstract', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'SR22orSR26Form', displayValue: 'SR22 or SR26 Form', description: 'SR22 or SR26 Form', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'DatabaseConversion', displayValue: 'Database Conversion', description: 'Database Conversion', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Telephone', displayValue: 'Telephone', description: 'Telephone', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Supplements', displayValue: 'Supplements', description: 'Supplements', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'TrafficSurvivalSchoolAssignmentForm', displayValue: 'Traffic Survival School Assignment Form', description: 'Traffic Survival School Assignment Form', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'UnitedStatesPostOffice', displayValue: 'United States Post Office', description: 'United States Post Office', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Verimove', displayValue: 'Verimove', description: 'Verimove', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'Warrant', displayValue: 'Warrant', description: 'Warrant', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'ServiceArizona', displayValue: 'Service Arizona', description: 'Service Arizona', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'AZMVDNow', displayValue: 'AZ MVD Now', description: 'AZ MVD Now', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'Verbal', displayValue: 'Verbal', description: 'Change was requested verbally', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'FAA', displayValue: 'FAA', description: 'FAA', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IAddressSourceType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IAddressSourceType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IAddressSourceType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IAddressSourceType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IAddressSourceType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
